<script setup>
import { AccordionItem, useForwardProps } from "reka-ui";

const props = defineProps({
  value: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "div" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <AccordionItem v-bind="forwarded" class="accordion-item">
    <slot />
  </AccordionItem>
</template>
